export const odinLoadingActions = {
  UPDATE_ODIN_LOADING_VALUE: 'UPDATE_ODIN_LOADING_VALUE'
}